import { userActions } from './actions';

const userInitState = {
  userList: null,
  userBasicList: null,
  user: null,
  loading: false,
  saving: false,
  error: null,
};

export function userReducer(state = userInitState, { type, payload }) {
  switch (type) {
    case userActions.LOAD_USER_LIST:
      return {
        ...state,
        loading: true,
      };
    case userActions.LOAD_USER_LIST_SUCCESS:
      return {
        ...state,
        userList: payload.data,
        loading: false,
      };
    case userActions.LOAD_USER_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: payload.error,
      };

    case userActions.LOAD_USER_BASIC_LIST:
      return {
        ...state,
        loading: true,
      };
    case userActions.LOAD_USER_BASIC_LIST_SUCCESS:
      return {
        ...state,
        userBasicList: payload.data,
        loading: false,
      };
    case userActions.LOAD_USER_BASIC_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: payload.error,
      };

    case userActions.LOAD_USER:
      return {
        ...state,
        loading: true,
      };
    case userActions.LOAD_USER_SUCCESS:
      return {
        ...state,
        user: payload.data,
        loading: false,
      };
    case userActions.LOAD_USER_FAIL:
      return {
        ...state,
        loading: false,
        error: payload.error,
      };

    case userActions.UPDATE_USER:
      return {
        ...state,
        saving: true,
      };
    case userActions.UPDATE_USER_SUCCESS:
      return {
        ...state,
        saving: false,
      };
    case userActions.UPDATE_USER_FAIL:
      return {
        ...state,
        saving: false,
        error: payload.error,
      };

    default:
      return state;
  }
}
